export const styles = {
  container: {
    minHeight: { xs: '100%', lg: '100%' },
    boxShadow: '0px 14.625px 80.4375px -21.9375px rgba(43, 37, 37, 0.12)',
    borderRadius: '10px',
    overflow: 'hidden',
  },
};
